import { render, staticRenderFns } from "./group-members.vue?vue&type=template&id=23adc323&scoped=true"
import script from "./group-members.vue?vue&type=script&lang=js"
export * from "./group-members.vue?vue&type=script&lang=js"
import style0 from "./group-members.vue?vue&type=style&index=0&id=23adc323&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23adc323",
  null
  
)

export default component.exports